export const EntrepriseCustomDataSettingType = {
  Number: 1,
  String: 2,
  Date: 3,
  Boolean: 4,
  Email: 5,
  PhoneNumber: 6,
  /** Choix unique parmi des libellés configurés par l'entreprise (voir `options`). */
  List: 7,
};

export type EntrepriseCustomDataSettingType =
  (typeof EntrepriseCustomDataSettingType)[keyof typeof EntrepriseCustomDataSettingType];

// Clé de traduction (web_entreprise.*) associée à chaque type de champ,
// pour éviter de dupliquer cette correspondance dans chaque page.
export const EntrepriseCustomDataSettingTypeTranslationKey: Record<
  EntrepriseCustomDataSettingType,
  string
> = {
  [EntrepriseCustomDataSettingType.Number]: "type_number",
  [EntrepriseCustomDataSettingType.String]: "type_string",
  [EntrepriseCustomDataSettingType.Date]: "type_date",
  [EntrepriseCustomDataSettingType.Boolean]: "type_boolean",
  [EntrepriseCustomDataSettingType.Email]: "type_email",
  [EntrepriseCustomDataSettingType.PhoneNumber]: "type_phone",
  [EntrepriseCustomDataSettingType.List]: "type_list",
};

export function buildEntrepriseCustomDataSettingTypeLabels(
  tEntreprise: (key: string) => string,
): Record<EntrepriseCustomDataSettingType, string> {
  return Object.fromEntries(
    Object.entries(EntrepriseCustomDataSettingTypeTranslationKey).map(
      ([type, key]) => [type, tEntreprise(key)],
    ),
  ) as Record<EntrepriseCustomDataSettingType, string>;
}

/**
 * Ce qu'un champ personnalisé d'entreprise vient renseigner. Les deux listes sont indépendantes :
 * un « Numéro de badge » sur les collaborateurs n'a rien à faire sur une réservation.
 */
export const EntrepriseCustomDataSettingCible = {
  /** Personnes de l'entreprise : collaborateurs (cliente) ou chauffeurs (partenaire). */
  Contact: 1,
  /** Courses facturées à l'entreprise, renseignées à la réservation. */
  Course: 2,
};

export type EntrepriseCustomDataSettingCible =
  (typeof EntrepriseCustomDataSettingCible)[keyof typeof EntrepriseCustomDataSettingCible];

export const EntrepriseCustomDataSettingCibleLabel: Record<
  EntrepriseCustomDataSettingCible,
  string
> = {
  [EntrepriseCustomDataSettingCible.Contact]: "Collaborateurs et chauffeurs",
  [EntrepriseCustomDataSettingCible.Course]: "Courses",
};
